<component
  v-if="iconComponent"
  :is="iconComponent"
  :color="color"
  :size="size"
  :width="width"
  :height="height"
  :tooltip-enabled="tooltipEnabled"
/>
